<template>
 <div> 
    <div v-for="(item,index) in list" :key="index">
        <div class="title1" :style="{'font-size':(fontsize-2)+'px'}">{{titleindex+'.'+(index+1)}}.{{ item.name }}</div>
         <template v-if="item.child&&item.child.length>0">
                   <child :list="item.child" :titleindex="titleindex+'.'+(index+1)" :fontsize="(fontsize-2)"></child>
                </template>
                <template v-else>
                    <editorfull v-model="item.content"></editorfull>
                    <div class="mt_20 flex flex-v textnowap" v-if="item.ckwxtype=='2'">参考文献：<el-input placeholder="请输入参考文献" v-model="item.ckwx"></el-input></div>
                </template>  
    </div>  
 </div>   
</template>
<script>
import  child from "@/components/child"
import editorfull from  "@/components/editorfull"
export default {
   components:{child,editorfull},
   name:'child',
    props:{
      list:{
        type:Array,
        default:function(){
          return []
        }
      },
      titleindex:{
        type:Number||String,
        default:'1'
      },
      fontsize:{
        type:Number,
        default:25
      },
    },
    data() {
      return {
       
      }
    },
    methods: {
      
    }
};
</script>
<style lang="less" scoped>
 .title1 {font-weight: bold;font-size:25px;margin-top:30px;margin-bottom: 10px;}
</style>